"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
// an object allows to share data between modules; it's needed because we use
// simplified ES modules there and cannot import and share a number
var _default = {
  nodeIndex: 0,
  allEvents: {}
};
exports["default"] = _default;
//# sourceMappingURL=_data.js.map